let noSelfie = false;

let quizProgressIndex = 0;
let canvas;
let overlays_container_div;
let selfie;

/*  --------------------------------------------  */

const progressBar = document.getElementById("tangent-progress-bar");
const quizBlock = document.getElementById("quiz-block");


function handleProgressLabel(current) {
    const blocks = document.querySelectorAll(".progress-category-block");

    blocks.forEach((block, index) => {
        let shouldActivate = false;

        if (index === 0) shouldActivate = current >= 1;
        if (index === 1) shouldActivate = current >= 4;
        if (index === 2) shouldActivate = current >= 5;

        if (shouldActivate && !block.classList.contains("fadeinAnimation")) {
            block.classList.add("fadeinAnimation");
        }

        if (!shouldActivate && block.classList.contains("fadeinAnimation")) {
            block.classList.remove("fadeinAnimation");
        }
    });
}

function applyProgress(current, total) {
    if (!total) return;
    const progress = Math.min((current / total) * 100, 100);
    progressBar.style.width = `${progress}%`;
}

function updateQuizProgressEvent(eventDetails) {
    const index = eventDetails[0];
    const progressData = {
        index: index
    }
    const event = new CustomEvent("tangent:quiz:progress", {
        detail: progressData
    })

    window.dispatchEvent(event);
}

function customQuestionViewEvent(questionText, questionId) {
    const event = new CustomEvent("tangent:quiz:question-viewed", {
        detail: {
            id: questionId,
            questionText: questionText
        }
    })
    window.dispatchEvent(event);
}

function getQuestionText(index, total) {
    if (index == 0) {
        return document.querySelector(".tangent-title-heading")?.innerText;
    } else if (index == 1 && !noSelfie) {
        return document.querySelector("#selfie-info-text")?.innerText;
    } else {
        return document.querySelector(".question-text")?.innerText;
    }
}

function handleLoadingAnimation() {

    const loaderContainer = document.querySelector(".loader-container");
    const quizContainer = document.getElementById("tangent-main-container");
    const progressFill = document.getElementById("progressFill");


    // loaderContainer.style.display = "block";
    // quizContainer.style.display = "none";

    const percent = document.getElementById("percent");
    const heading = document.querySelector(".loading-message");


    const loadingText = [
        "Analyzing your hair profile...",
        "Evaluating texture & condition...",
        "Cross-referencing 50+ product formulas...",
        "Matching products to your goals...",
        "Building your personalized routine...",
        "Finalizing recommendations...",
        "Your routine is ready!"
    ];

    const duration = 7000;

    // change text every 1 second
    loadingText.forEach((text, index) => {
        setTimeout(() => {
            if (heading) heading.textContent = text;
        }, index * 1000);
    });

    let start = Date.now();
    let isCardAnimationAdded = false;
    let isTestimonialCardAdded = false;

    const percentInterval = setInterval(() => {

        const elapsed = Date.now() - start;
        const progress = Math.min((elapsed / duration) * 100, 100);

        percent.textContent = Math.floor(progress) + "%";
        progressFill.style.width = `${Math.floor(progress)}%`;

        if (progress >= 100) {
            clearInterval(percentInterval);
            // setTimeout(() => {
            //     quizContainer.style.display = "block";
            //     loaderContainer.style.display = "none";
            //     progressFill.style.width = "0%";
            // }, 1000)
        }

    }, 50);
}

function hasInputError() {
    const errorElements = document.querySelectorAll(".tangent_input_error_style_custom");

    for (const el of errorElements) {
        if (el.innerText.trim()) return true;
    }
    return false;
}


window.addEventListener("quiz_initialized", (e) => {
    let [current, total, fromQuestionId, toQuestionId] = event.detail.split("_");
    const questionText = getQuestionText(Number(current), Number(total));
    customQuestionViewEvent(questionText, toQuestionId);
})

window.addEventListener("quiz_progress", (event) => {
    const progressWrapper = document.getElementById("progress-wrapper");
    let [current, total, fromQuestionId, toQuestionId] = event.detail.split("_");
    current = Number(current);
    total = Number(total);
    applyProgress(current, total - 1);
    updateQuizProgressEvent(event.detail.split("_"))
    handleProgressLabel(current)
    const imgBlock = document.getElementById("selfie-img-container");
    const customBtn = document.getElementById('customSubmitBtn');
    const customSkipBtn = document.getElementById('customSkipBtn');

    if (current == 0) {
        progressWrapper.style.display = "none";
    } else {
        progressWrapper.style.display = "flex";
    }

    setTimeout(() => {
        if (current != 0 && current > quizProgressIndex) {
            const questionTextBlock = document.querySelector(`.tangent_${toQuestionId}_question_text_custom`)
            const optionBlockClass = `.tangent_${toQuestionId}_options_container_custom`;
            const optionsBlock = document.querySelector(optionBlockClass)
            if (questionTextBlock && optionsBlock) {
                questionTextBlock.style.opacity = "0";
                questionTextBlock.classList.add("slideIn_animation");
                optionsBlock.style.opacity = "0";
                optionsBlock.classList.add("slideIn_animation");
            }
        }
        if (current != 0 && current < quizProgressIndex) {
            const questionTextBlock = document.querySelector(`.tangent_${toQuestionId}_question_text_custom`)
            const optionBlockClass = `.tangent_${toQuestionId}_options_container_custom`;
            const optionsBlock = document.querySelector(optionBlockClass);
            if (questionTextBlock && optionsBlock) {
                questionTextBlock.classList.add("slide-from-left");
                optionsBlock.classList.add("slide-from-left");
            }
        }
        quizProgressIndex = current;
        if (current == total) {
            handleLoadingAnimation();
        }
    }, 50)

    if (current != total) {
        setTimeout(() => {
            const questionText = getQuestionText(current, total);
            customQuestionViewEvent(questionText, toQuestionId);
        }, 100)
    }
});